"use client";

import { useBackUrl } from "@erp/shared-libs/hooks";
import { IRoute } from "@erp/shared-libs/utils";
import Link from "next/link";
import { ComponentProps, useCallback } from "react";

// =======================================================
// Props
// =======================================================
interface LinkWithAnchorKeyProps extends ComponentProps<typeof Link> {
  href: string;
  route: IRoute;
  anchorKey?: string | number;
}

// =======================================================
// Component
// =======================================================
export function LinkWithAnchorKey({ href, route, anchorKey, ...props }: LinkWithAnchorKeyProps) {
  const { combineAnchorKey } = useBackUrl(route);

  const handleInsertAnchorBeforeNavigate = useCallback(() => {
    const replaceUrl = combineAnchorKey(window.location.href, anchorKey);
    window.history.replaceState({}, "", replaceUrl);
  }, [anchorKey, combineAnchorKey]);

  return (
    <Link href={href} prefetch={false} onNavigate={handleInsertAnchorBeforeNavigate} {...props} />
  );
}
